import { NEWBIE_FACTOR } from "../constants_v2.js";

const formulaSplainer = () => {
  return `
    <br>
    <div class="left">
    <p>The factors are:</p>  
    <p>Win Rate * Unique Account Win Rate * Newbie Factor * 1,000</p>
    <p>Win Rate is your total wins / total matches</p>
    <p>Unique Account Win Rate is the same as above, except it excludes when you play the same player over and over.</p>
    <p>The Newbie Factor discounts your first matches, each one a little less, until ${NEWBIE_FACTOR}. Without this, the leaderboard would forever show new players who won their first match, because that is a 100% win rate. </p>
    <div>`;
};

const generateHTML = (account) => {
  const totalWins = account?.totalWins ?? 0;
  const totalFinishes = account?.totalFinishes ?? 0;
  const uniqueWins = account.uniqueWins ?? 0;
  const uniqueFinishes = account.uniqueFinishes ?? 0;
  const rank = account.rank.slice(0, 4);
  let formulaHTML = `<div class="formulaFlex">`;
  formulaHTML += `<div class="leaderCenterVert noWrap">${rank} =</div>`;
  formulaHTML += `<div class="paren">(</div><div class="leaderFlexColumn"><div class="numerator">${totalWins}</div><div>${totalFinishes}</div></div><div class="paren">)</div>`;
  formulaHTML += `<div class="asterisk">*</div>`;
  formulaHTML += `<div class="paren">(</div><div class="leaderFlexColumn"><div class="numerator">${uniqueWins}</div><div>${uniqueFinishes}</div></div><div class="paren">)</div>`;
  formulaHTML += `<div class="asterisk">*</div>`;
  formulaHTML += `<div class="paren">(</div><div class="leaderFlexColumn"><div class="numerator">${uniqueFinishes > NEWBIE_FACTOR ? NEWBIE_FACTOR : uniqueFinishes}</div><div>${NEWBIE_FACTOR}</div></div><div class="paren">)</div>`;
  formulaHTML += `<div class="asterisk">*</div>`;
  formulaHTML += `<div class="leaderCenterVert">1000</div>`;
  formulaHTML += "</div>";

  return formulaHTML + formulaSplainer();
};

export const rankFormula = {
  generateHTML,
};
